import { injectable } from "@launchtray/tsyringe-async";
import { TriangleRotationStatus } from "../../../enums/TriangleRotationStatus";
import { ITriangleModelFactory } from "../ITriangleModelFactory";
import { TriangleModel } from "../../../models/triangle/impl/TriangleModel";
import { PieceColor } from "../../../enums/PieceColor";

@injectable()
export class TriangleModelFactory implements ITriangleModelFactory {
    public constructor(
        private readonly ctor: new(rotationStatus: TriangleRotationStatus, color: PieceColor) => TriangleModel
    ) { }

    public createTriangle(rotationStatus: TriangleRotationStatus, color: PieceColor): TriangleModel {
        return new this.ctor(rotationStatus, color);
    }
}